import React, { FunctionComponent } from 'react'
import { Text } from '@wework/dieter-ui'
import Row from '../Common/Row'
import IMTheme from '../../style/IMTheme'
import RoomPlaceholder from '../../assets/images/RoomPlaceholder.svg'

interface LinkedRoomProps {
  roomNumber: string
  floor?: string
  handleInternalRoomClick: any
}
const LinkedRoom: FunctionComponent<LinkedRoomProps> = ({
  roomNumber,
  floor,
  handleInternalRoomClick,
}) => {
  return (
    <Row
      className={'row'}
      style={{
        cursor: 'pointer',
        border: `1px solid ${IMTheme.colors.gray}`,
        borderRadius: '4px',
        marginBottom: IMTheme.spacing[2],
        padding: IMTheme.spacing[3],
      }}
      justify="flex-start"
    >
      <div
        style={{
          width: '48px',
          height: '48opx',
        }}
      >
        <RoomPlaceholder />
      </div>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          marginLeft: IMTheme.spacing[4],
        }}
      >
        <Text
          primary
          style={{
            fontSize: IMTheme.fontSizes[2],
            fontWeight: IMTheme.fontWeights.bold,
          }}
          onClick={() => handleInternalRoomClick()}
        >
          {roomNumber}
        </Text>
        <Text
          primary
          style={{
            fontSize: IMTheme.fontSizes[2],
            fontWeight: IMTheme.fontWeights.normal,
            color: IMTheme.colors.darkGray,
          }}
        >
          {floor}
        </Text>
      </div>
    </Row>
  )
}

export default LinkedRoom
